module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b",
    attrs: {
      "id": "frontmatter"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lengthy conversations with Pamela Nadell, Julie Galambush, and Linda Schermer Raphael helped me organize this book. Tamara Cooper assisted me continuously with the technology needed for conveying the manuscript in the proper manner to the press. Jeffrey Gurock read the entire manuscript and made critical suggestions for improvement. And Jennifer Hammer, editor extraordinaire at New York University Press, who approached me to write a history of the synagogue in America, improved every paragraph of this book not only in style but in content."), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e949be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter.vue
// module id = 69
// module chunks = 0